import React from 'react'
import classNames from 'classnames'

import { ReactComponent as ProcessDocumentUploadIcon } from '../../../assets/images/process-document-upload-icon.svg'

import { useProcessDocumentFileInput } from '../hooks'

import './ProcessDocumentFileInput.scss'

const _SUPPORTED_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]

interface ProcessDocumentFileInputProps {
  onFilesSelected: (files: File[]) => Promise<void>
  multiple?: boolean
  disabled?: boolean
  browseAction?: React.ReactNode
}

export const ProcessDocumentFileInput: React.FC<ProcessDocumentFileInputProps> = ({ onFilesSelected, multiple = false, disabled = false, browseAction }) => {
  const { isHovering, handleChange, handleDragEnter, handleDragLeave, handleDragOver, handleDrop } = useProcessDocumentFileInput(
    _SUPPORTED_MIME_TYPES,
    onFilesSelected,
    disabled,
  )

  return (
    <>
      <input
        id='process-document-file-input'
        multiple={multiple}
        type='file'
        accept={_SUPPORTED_MIME_TYPES.join(',')}
        onChange={handleChange}
        hidden={true}
        disabled={disabled}
      />
      <label
        htmlFor='process-document-file-input'
        className={classNames(
          'd-flex flex-column align-items-center justify-content-center zocks-py-3.0 rounded-3 zocks-border-dashed zocks-bg-color-gray-100 process-document-file-input-label',
          {
            'process-document-file-input-label-hovering': isHovering,
            'process-document-file-input-label-disabled': disabled,
          },
        )}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
      >
        <ProcessDocumentUploadIcon className='process-document-file-input-icon zocks-mb-1.5' />
        <div className='d-flex flex-column align-items-center zocks-gap-0.25'>
          <span className='paragraph-medium bold zocks-text-gray-900'>Drop your file here or click to browse</span>
          <span className='paragraph-small zocks-text-gray-700'>Supported formats: PDF, PNG, JPG, DOCX, XLSX</span>
        </div>
        {browseAction ? (
          <div className='w-100 zocks-mt-2.0' onClick={(e) => e.stopPropagation()}>
            {browseAction}
          </div>
        ) : null}
      </label>
    </>
  )
}
